

import {Component, EventEmitter, Output} from '@angular/core';
import {ClassificationService} from '../../../services/classification/classification.service';
import {TranslateService} from '@ngx-translate/core';
import {DataTableField} from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {ClassificationType} from '../../../models/classification.model';
import {DataTableService} from '../../../modules/UIKit/components/dataTable/dataTable.service';
import {DataTableCustomButton} from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';

@Component({
  selector: 'app-kv-classification-types',
  template: `
    <kv-datatable
    [allowsMultiSelection]="false"
    id="dt_classification_types"
    sectionTitle="{{ 'common.classification_types_title' | translate }}"
    listTitle="{{ 'common.classification_types_list_title' | translate }}"
    [numRowsPerPage]="10"
    [titles]="titles"
    [items]="this.svc.types"
    deleteButton="{{ 'common.delete' | translate }}"
    addButton="{{ 'common.add' | translate }}"
    (onAdd)="showAddDialog($event)"
    (onCancelDetail)="this.svc.editing=null"
    [editable]="true"
    (onEditInline)="onEditInline($event)"
    (onDelete)="onDeleteInline($event)"
    [customButtons]="customButtons"
    (onCustomButton)="onCustomButton($event)"
    >
      <app-kv-classification-types-form
        *ngIf="this.svc.editingType"
        [editingElement]="this.svc.editingType"
        (onAddElement)="onAdd($event)"
      >
      </app-kv-classification-types-form>
    </kv-datatable>
  `
})

export class ClassificationTypes2Component {

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  @Output() onBackClick: EventEmitter<any> = new EventEmitter();

  constructor (public svc: ClassificationService,
               private translate: TranslateService,
               private srvDataTable: DataTableService) {
    this.svc.getTypes().subscribe();

    this.translate.get([
      'common.classification_types_name',
      'common.back'
    ]).subscribe((res) => {
      console.log(res);
      this.titles = [
        { id: 'id', label: '#' },
        { id: 'name', label: res['common.classification_types_name'], editable: true },
      ];

      this.customButtons = [
        {
          callbackname: 'back',
          isAlwaysEnabled: true,
          label: res['common.back'],
          icon: 'fa fa-angle-double-left'
        }
      ]

    })
  }

  onEditInline(event) {
    this.svc.putType(event).subscribe();
    this.svc.editingType = null;
  }

  onDeleteInline(event) {
    this.svc.deleteType(event).subscribe();
  }

  onAdd(event) {
    this.svc.postType(event).subscribe();
    this.svc.editingType = null;
    this.srvDataTable.get('dt_classification_types').showDetail = false;

  }

  showAddDialog(data) {
    this.svc.editingType = new ClassificationType();
  }

  onCustomButton(event) {
    switch (event.callbackName) {
      case 'back':
        this.onBackClick.emit();
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-types.component.ts